import { render } from "./product.vue?vue&type=template&id=3c93e0b9&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=3c93e0b9&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c93e0b9"]])

export default __exports__